var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"supply"},[_c('div',{staticClass:"title"},[_c('h5',{class:_vm.isLeftMore == true ? 'leftMore' : ''},[_vm._v(_vm._s(_vm.title))]),[_vm._t("topRight")]],2),(_vm.isAll)?[_c('div',{staticClass:"card-body"},[_vm._t("default")],2)]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }